module.exports = "https://99designs-start-assets.imgix.net/js/18d1800ba6d2671ed348e2816a2c4174.png";